import { Box, Collapse } from "@mui/material";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { RadioField } from "@/components";
import { LocationResolutionFilterData, LocationResolutionFilterMetadata } from "@/types/playground";

import { LocationTypeGroupFilterOptionMetadata } from "./locationTypeGroupFilterOptionMetadata";
import { LocationTypeGroupFilterOptionType } from "./types";

export type LocationTypeGroupFilterOptionProps = {
  postalCode: string;
  setPostalCode: (postalCode: string) => void;
  onEnterPostalCodeValue: () => void;
  locationTypeGroupFilterOption: LocationTypeGroupFilterOptionType;
  locationResolution: LocationResolutionFilterData;
  onLocationResolutionMetadataChange: (metadata: LocationResolutionFilterMetadata) => void;
};

export const LocationTypeGroupFilterOption = ({
  postalCode,
  setPostalCode,
  onEnterPostalCodeValue,
  locationTypeGroupFilterOption,
  locationResolution,
  onLocationResolutionMetadataChange,
}: LocationTypeGroupFilterOptionProps): JSX.Element => {
  const { t } = useTranslation("PlaygroundPage");
  const isSelectedOption = locationTypeGroupFilterOption.type === locationResolution.type;

  return (
    <>
      <Box>
        <RadioField
          key={locationTypeGroupFilterOption.type}
          label={t(locationTypeGroupFilterOption.label)}
          value={locationTypeGroupFilterOption.type}
          selected={isSelectedOption}
        />
      </Box>
      <Collapse in={isSelectedOption}>
        <LocationTypeGroupFilterOptionMetadata
          postalCode={postalCode}
          setPostalCode={setPostalCode}
          onEnterPostalCodeValue={onEnterPostalCodeValue}
          locationResolutionType={locationTypeGroupFilterOption.type}
          locationResolution={locationResolution}
          onLocationResolutionMetadataChange={onLocationResolutionMetadataChange}
        />
      </Collapse>
    </>
  );
};
